import(/* webpackMode: "eager" */ "C:\\Users\\NEXBUILD\\Downloads\\NexBuild-main\\NexBuild-main\\src\\app\\page.tsx");
